import { useState } from 'react';
import { useData } from 'context/data.context';
import HistoricLineGraphCard from '../cards/timeline.line.graph';
import PeriodSelector from '../cards/timeperiod.card';

const HistoryPanel = () => {
  const { networthHistoric } = useData();
  const [period, setPeriod] = useState('all');

  return (
    <div className="History dark">
      <div className=" card no-bg flex col large-gap">
        <div className="flex row space center">
          <p className="xlarge padding">Timeline</p>
        </div>
        <HistoricLineGraphCard networthHistoric={networthHistoric} period={period} />
        <PeriodSelector period={period} setPeriod={setPeriod} />
      </div>
    </div>
  );
};

export default HistoryPanel;
